.list {
  list-style: none;
  margin: 0;
  padding: var(--space-3) 0;
}

.row {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr) 110px;
  align-items: center;
  gap: var(--space-4);
  height: 36px;
  padding: 0 var(--space-5);
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.value {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  font-size: var(--text-sm);
  font-weight: var(--weight-semi);
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}

.share {
  width: 36px;
  text-align: right;
  font-weight: var(--weight-regular, 400);
  color: var(--text-muted);
}

.legend {
  padding: 0 0 var(--space-4);
}

.list[data-label='sm'] .row {
  grid-template-columns: 64px minmax(0, 1fr) 56px;
  height: 28px;
  padding: 0;
}
